import classNames from "classnames";
import { enGB } from "date-fns/locale";
import React from "react";

import { formatDate } from "@utils/date";

import { useStorePickerContext } from "@components/Store/StorePicker/storePicker.context";
import { StorePickerStore } from "@components/Store/StorePicker/types/storePickerStore.types";
import { StorePickerType } from "@components/Store/StorePicker/types/storePickerType.enum";

import { StoreDistanceComponent } from "../../../../../shared/storeDistance/storeDistance.component";
import { StoreOpeningHoursComponent } from "./components/storeOpeningHours/storeOpeningHours.component";
import { StoreProductAvailabilityComponent } from "./components/storeProductAvailability/storeProductAvailability.component";
import "./storeCard.scss";

type StoreCardProps = {
    store: StorePickerStore;
};

const StoreCardComponent = ({ store }: StoreCardProps) => {
    const { selectedStore, setSelectedStore, config } = useStorePickerContext();

    const address = `${store.address.streetName} ${store.address.streetNumber}, ${store.address.postalCode} ${store.address.town}`;

    const selected = store.code === selectedStore?.code;

    let weekDay = formatDate(new Date(), "eeee", {
        locale: enGB,
    }).toUpperCase();

    const openingsHours = store.weekDayOpenings
        ? store.weekDayOpenings[weekDay]
        : undefined;

    const handleOnStoreClick = () => {
        if (config.type !== StorePickerType.INFO) {
            setSelectedStore(store);
        }
    };

    return (
        <li
            className={classNames(
                "store-card",
                selected && "store-card--selected",
            )}
            onClick={handleOnStoreClick}
        >
            <p className={"store-card__title"}>
                {store.storeName}
                {store.distancePromise && (
                    <StoreDistanceComponent
                        distancePromise={store.distancePromise}
                    />
                )}
            </p>
            {openingsHours && (
                <StoreOpeningHoursComponent hours={openingsHours} />
            )}
            <p className={"m-0"}>
                <i className={"mr-2 las la-map-marker"}></i>
                {address}
            </p>
            {store.productAvailability && (
                <StoreProductAvailabilityComponent
                    productAvailability={store.productAvailability}
                />
            )}
        </li>
    );
};

export { StoreCardComponent };
